<template>
  <div id="footerTemp" style="color:#42b983">
    <footer>written by {{author|uppercase}} {{now}} CopyRight@xqzh </footer>
  </div>
</template>

<script>
export default {
  data () {
    return {
      author:"john"
    }
  },
  props:['now'],
}
</script>

<style>
#footerTemp {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;

}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

#author {
  color: #42b983;
}

</style>



// WEBPACK FOOTER //
// footerTemp.vue?4952ac3f